<div class="wrapper">
  <h1>core component</h1>
</div>
